import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { InputAdornment, IconButton, TextField } from '@mui/material';
import { IconCalendarWeek, IconX } from '@tabler/icons-react';
import dayjs from 'dayjs';

export default function SingleDatePicker({ selectedDate, setSelectedDate, isClearable = true, height = 42 }) {
  const handleClear = (event) => {
    event.stopPropagation();
    setSelectedDate(null);
  };

  const hasDate = selectedDate && dayjs(selectedDate).isValid();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        value={selectedDate ? dayjs(selectedDate) : null}
        onChange={(newValue) => setSelectedDate(newValue)}
        format="DD/MM/YYYY"
        slots={{
          textField: TextField,
        }}
        slotProps={{
          textField: (params) => ({
            ...params,
            fullWidth: true,
            size: "small",
            sx: {
              minWidth: 220,
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                height,
              },
            },
            InputProps: {
              ...params.InputProps,
              style: { height },
              endAdornment: (
                <React.Fragment>
                  {isClearable && hasDate && (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={handleClear}
                        onMouseDown={(e) => e.stopPropagation()}
                        sx={{
                          padding: '2px',
                          color: "error.main",
                          '&:hover': {
                            backgroundColor: 'error.light',
                          },
                          mr: 0.5
                        }}
                      >
                        <IconX size="1.1rem" stroke={3} />
                      </IconButton>
                    </InputAdornment>
                  )}
                  {params.InputProps?.endAdornment}
                </React.Fragment>
              ),
            },
          }),
        }}
      />
    </LocalizationProvider>
  );
}